import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';

export const LocaleLiteralCodeChanged = createAction(
  '[Locale Literals]: Literal Code Changed',
  props<{ localeLiteralCode: string }>(),
);

export const LocaleLiteralTextChanged = createAction(
  '[Locale Literals]: Literal Text Changed',
  props<{ localeLiteralText: string }>(),
);

export const UpdateLocaleLiteral = createAction('[Locale Literals]: Update Locale Literal');

export const UpdateLocaleLiteralSuccess = createAction(
  '[Locale Literals]: Update Locale Literal Success',
  props<{ res: QcResponseGrid }>(),
);

export const UpdateLocaleLiteralFailed = createAction(
  '[Locale Literals]: Update Locale Literal Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CreateNewLiteralsChanged = createAction(
  '[Locale Literals]: Create New Literals Changed',
  props<{ index: number; localizedString: string; languageId: number }>(),
);

export const CreateNewLiterals = createAction('[Locale Literals]: Create New Literals');

export const CreateNewLiteralsSuccess = createAction(
  '[Locale Literals]: Create New Literals Success',
  props<{ res: QcResponseGrid }>(),
);

export const CreateNewLiteralsFailed = createAction(
  '[Locale Literals]: Create New Literals Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const SubmitLocaleData = createAction('[Locale Literals]: Submit Locale Data');
